import React from 'react';
import { Container } from 'react-bootstrap'
import Footer from './components/Footer'
import Header from './components/Header'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import PreLoader from './components/PreLoader';
import CookieBanner from './components/CookieBanner';



import StartScreen from './screens/StartScreen'
import ShopScreen from './screens/ShopScreen'
import DisplayScreen from './screens/DisplayScreen'
import ProductScreen from './screens/ProductScreen'
import CartScreen from './screens/CartScreen'
import LoginScreen from './screens/LoginScreen' 
import RegisterScreen from './screens/RegisterScreen'
import ProfileScreen from './screens/ProfileScreen' 
import ShippingScreen from './screens/ShippingScreen'  
import PaymentScreen from './screens/PaymentScreen'
import PlaceOrderScreen from './screens/PlaceOrderScreen'
import OrderScreen from './screens/OrderScreen'
import UserListScreen from './screens/UserListScreen'
import UserEditScreen from './screens/UserEditScreen'
import ProductListScreen from './screens/ProductListScreen'
import ProductEditScreen from './screens/ProductEditScreen'
import OrderListScreen from './screens/OrderListScreen'
import CommentListScreen from './screens/CommentListScreen'
import PostListScreen from './screens/PostListScreen'
import OuterPostListScreen from './screens/OuterPostListScreen'
import CreateOuterPostScreen from './screens/CreateOuterPostScreen';
import PublicForumScreen from './screens/PublicForumScreen';
import PostScreen from './screens/PostScreen';
import OuterPostScreen from './screens/OuterPostScreen';


function App() {
 

  return (
  <>
  <PreLoader/>
  <CookieBanner/>
    <Router>

    <Route
          render={({ location }) => (
            location.pathname !== '/test' && <Header />
          )}
        />
      <main className="py-3">
        <Container>

            <Switch>
              <Route path='/' component={StartScreen} exact/> {/* exact necessario: senza, questa rotta "vince" su tutte le altre */}
              {/* <Route path='/home' component={DisplayScreen}/>
              <Route path='/post/:id' component={PostScreen}/> */}
              <Route path='/shop' component={ShopScreen}/>
              <Route path='/login' component={LoginScreen} />
              <Route path='/register' component={RegisterScreen} />
              <Route path='/profile' component={ProfileScreen} />
              <Route path='/shipping' component={ShippingScreen}/>
              <Route path='/payment' component={PaymentScreen}/>
              <Route path='/placeorder' component={PlaceOrderScreen}/>
              <Route path='/order/:id' component={OrderScreen}/>
              

              <Route path='/forum' component={PublicForumScreen} exact/>
              <Route path='/outPost/:id' component={OuterPostScreen} />
              <Route path='/createOutPost' component={CreateOuterPostScreen}/>

              <Route path='/product/:id' component={ProductScreen} />
              <Route path='/cart/:id?' component={CartScreen}/>

              <Route path='/admin/userlist' component={UserListScreen}/>
              <Route path='/admin/user/:id/edit' component={UserEditScreen}/>

              <Route path='/admin/productlist' component={ProductListScreen}/>
              <Route path='/admin/product/:id/edit' component={ProductEditScreen}/>
              
              <Route path='/admin/orderlist' component={OrderListScreen}/>
              <Route path='/admin/commentlist' component={CommentListScreen}/>
              <Route path='/admin/postlist' component={PostListScreen}/>
              <Route path='/admin/outerpostlist' component={OuterPostListScreen}/>
            </Switch>

        </Container>
      </main>
      <Route
          render={({ location }) => (
            location.pathname !== '/test' && <Footer />
          )}
        />
      
    </Router>
  </>
  );
}

export default App;